<template>
<div class="App-page">
  <!-- <img src="../public/网站 碳立方logo.png" alt="Logo" /> -->
<router-view></router-view>
</div>
</template>
<script>
export default {
  name: 'App'
  // mounted () {
  //   const that = this
  //   // 这里的this.width和this.height就是main.js中全局挂载的两个变量
  //   this.pageSize(this.width, this.height)
  //   console.log(this.width, this.height)
  //   window.addEventListener('resize', function () {
  //     // 这里传的参数是当前浏览器窗口的宽高
  //     that.pageSize(window.innerWidth, window.innerHeight)
  //   })
  // },
  // methods: {
  //   pageSize (w, h) {
  //     const appDiv = document.body
  //     if (w === window.screen.width) {
  //       if (!this.isFullscreenForNoScroll()) {
  //         // 浏览器最大化但是未全屏
  //         appDiv.style.maxWidth = w + 'px'
  //         appDiv.style.maxHeight = h + 'px'
  //         appDiv.style.minWidth = w + 'px'
  //         appDiv.style.minHeight = h + 'px'
  //       } else {
  //         // 浏览器最大化且全屏
  //         appDiv.style.maxWidth = window.screen.width + 'px'
  //         appDiv.style.maxHeight = window.screen.height + 'px'
  //         appDiv.style.minWidth = window.screen.width + 'px'
  //         appDiv.style.minHeight = window.screen.height + 'px'
  //       }
  //     } else {
  //       // 浏览器不是最大化
  //       appDiv.style.maxWidth = this.width + 'px'
  //       appDiv.style.maxHeight = this.height + 'px'
  //       appDiv.style.minWidth = this.width + 'px'
  //       appDiv.style.minHeight = this.height + 'px'
  //     }
  //   },
  //   isFullscreenForNoScroll () {
  //     let wholeScreenFlag = false
  //     var explorer = window.navigator.userAgent.toLowerCase()
  //     if (explorer.indexOf('chrome') > 0) {
  //       // webkit
  //       if (window.innerHeight === window.screen.height) {
  //         wholeScreenFlag = true
  //       } else {
  //         wholeScreenFlag = false
  //       }
  //     } else {
  //       // IE 9+  fireFox
  //       if (window.outerHeight === window.screen.height) {
  //         wholeScreenFlag = true
  //       } else {
  //         wholeScreenFlag = false
  //       }
  //     }
  //     return wholeScreenFlag
  //   }
  // }
}
</script>

<style scoped>
</style>
